import { FC } from 'react';
import { Box, Grid, Flex } from '@chakra-ui/react';
import Teaser, { Props as TeaserProps } from './Teaser';
import Image from './Image';

/* NOTE: the pure CSS solution to the swapping of teasers is not 100% brilliant, but it does the job well enough
 * Fully supports mirrorin the teasers when displayed within a container.
 * Supports mirroring up to 3 elements when displayed in a non-controller environment (acf/large-teaser eg.)
 *
 * This could be fixed with eg. Provider or maybe extra index prop in the data, but neither of those seem worth it considering the use cases.
 */
const iffyMirrorCss = {
  '.split-teaser:not(.split-teaser + .split-teaser) + &.split-teaser > div': {
    direction: 'rtl',
  },
  '.split-teaser:not(.split-teaser + .split-teaser) + &.split-teaser > div > *':
    { direction: 'ltr' },
};

const mirrorCssWithContainer = {
  ':nth-of-type(even) > div': { direction: 'rtl' },
  ':nth-of-type(even) > div > *': { direction: 'ltr' },
};

const TeaserSplit: FC<
  TeaserProps & { className?: string; hasContainer?: boolean }
> = ({
  image,
  as,
  heading,
  className,
  hasContainer = false,
  ...teaserProps
}) => (
  <Box
    borderRadius="lg"
    boxShadow="sm"
    as={as}
    sx={hasContainer ? mirrorCssWithContainer : iffyMirrorCss}
    className={[className, 'split-teaser'].filter(Boolean).join(' ')}
  >
    <Grid
      justifyContent="center"
      pos="relative"
      borderRadius="inherit"
      overflow="hidden"
      gridTemplateColumns={[
        'repeat(auto-fit, minmax(270px, 1fr))',
        'repeat(auto-fit, minmax(356px, 1fr))',
      ]}
    >
      <Image
        src={image?.src || ''}
        alt={
          image?.alt ??
          ((typeof heading?.title === 'string' && heading?.title) || '')
        }
        width="900"
        height="650"
        containerProps={{ d: 'flex' }}
        noRounding
      />
      <Teaser
        as={Flex}
        justifyContent="center"
        alignItems="center"
        innerProps={{
          width: '100%',
          px: [2, 4, 'calc(var(--chakra-space-4) + 5vw)'],
        }}
        bg="white"
        heading={{ variant: 'h4', ...heading }}
        {...teaserProps}
      />
    </Grid>
  </Box>
);

export default TeaserSplit;
